import { css } from "styled-components";
import { BladeHeader } from "../../../../../../components/BladeHeader";
export const riotProductSkin = (chroma) => css `
  ${BladeHeader} {
    position: relative;
    white-space: pre-line;
    max-width: unset;
    width: 100%;

    .bladeheader-heading > * {
      &:not(.ctaContainer) {
        max-width: 647px;
        width: 100%;
      }

      &.game-icon-no-label {
        display: flex;
        justify-content: center;
      }
    }
  }

  .ctaContainer {
    display: flex;
    flex: 1;
    flex-direction: row;
    gap: 32px;
    align-items: start;

    ${chroma.mediaQueries.tabletDown} {
      flex-direction: column;
      gap: 10px;
    }
  }
`;
//# sourceMappingURL=index.js.map